import React, { Component } from 'react'
import { connect } from 'react-redux'

import { isInviteOnboardingStep } from 'data/userPreferences/selectors'
import { getOrganization } from 'data/organizations/selectors'
import { isCurrentUserTheOwner } from 'data/users/selectors'
import { actions as ContactUserActions } from 'data/contactUser'
import { closeActiveModal } from 'data/ui/actions'
import { goToAppropriateUserOnboardingStep } from 'data/onboarding/actions'

import ModalBody from 'components/Utils/Modal/Body'
import { Header, Footer } from './Layout'
import { Button, Text } from 'components/base'
import SendInvitationsForm from 'components/Invitations/SendInvitationsForm'
import { hotjarTrigger } from 'helpers/windowHelpers'

class StepInviteByEmails extends Component {
  componentWillMount() {
    const {
      fetchMyOrganizationContacts,
      isInviteOnboardingStep,
      isCurrentUserTheOwner,
    } = this.props
    fetchMyOrganizationContacts()

    // Hotjar's trigger for new user onboarding
    isInviteOnboardingStep &&
      isCurrentUserTheOwner &&
      hotjarTrigger('onboardingInviteModalOwner')
  }

  skipNow = () => {
    this.props.closeActiveModal()
    if (
      this.props.goToAppropriateUserOnboardingStep &&
      this.props.isInviteOnboardingStep
    ) {
      this.props.goToAppropriateUserOnboardingStep()
    }
  }

  render() {
    const { organization } = this.props
    return (
      <ModalBody>
        <Header>
          <div className="flexbox margin-bottom-large">
            <div>
              <Text.Subtitle>Add people to {organization.name}</Text.Subtitle>
            </div>
          </div>
        </Header>
        <SendInvitationsForm afterSubmit={this.afterSubmit}>
          {({ getEmails, onSubmit }) => (
            <Footer>
              <Button.Secondary onClick={this.skipNow}>
                Not now
              </Button.Secondary>
              <div className="flexbox flexbox-align-center">
                <Button.Primary
                  onClick={onSubmit}
                  className="margin-left-normal"
                  disabled={!Boolean(getEmails().length)}
                >
                  Send invites
                </Button.Primary>
              </div>
            </Footer>
          )}
        </SendInvitationsForm>
      </ModalBody>
    )
  }

  afterSubmit = () => {
    this.props.closeActiveModal()
    if (this.props.isInviteOnboardingStep) {
      this.props.goToAppropriateUserOnboardingStep()
    }
  }
}

export default connect(
  state => {
    return {
      isInviteOnboardingStep: isInviteOnboardingStep(state),
      organization: getOrganization(state),
      isCurrentUserTheOwner: isCurrentUserTheOwner(state),
    }
  },
  {
    fetchMyOrganizationContacts: ContactUserActions.fetchMyOrganizationContacts,
    closeActiveModal,
    goToAppropriateUserOnboardingStep,
  }
)(StepInviteByEmails)
